import React, { Fragment, Suspense } from 'react'
import { ApolloProvider } from '@apollo/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import de from 'react-intl/locale-data/de'
import { ScrollToTop } from 'abihome-components'

import theme from './styles/theme'
import GlobalStyle from './styles/global'
import Routes from './components/Routes'
import SuspenseFallback from './components/SuspenseFallback'
import DefaultLayout from './layouts/DefaultLayout'
import DE from './i18n/de'
// import EN from './i18n/en'
import client from './graphql'

addLocaleData([...en, ...de])

const App = () => (
  <Fragment>
    <GlobalStyle />
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <IntlProvider locale='de' messages={DE}>
          <BrowserRouter>
            <ScrollToTop>
              <DefaultLayout>
                <Suspense fallback={<SuspenseFallback />}>
                  <Routes />
                </Suspense>
              </DefaultLayout>
            </ScrollToTop>
          </BrowserRouter>
        </IntlProvider>
      </ThemeProvider>
    </ApolloProvider>
  </Fragment>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js